import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { MyToursState } from './my-tours.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([MyToursState])],
  declarations: []
})
export class MyToursStoreModule {}
